<template>
    <div>
        <v-layout>
            <v-app-bar
                color="#5B951A"
                prominent
            >
                <v-toolbar-title>Синхронизация аналитики ККМ</v-toolbar-title>
            </v-app-bar>

            <v-main style="min-height: calc(100vh - 64px) !important;">
                <v-card-text class="fill-height">
                    <router-view></router-view>
                </v-card-text>
            </v-main>
        </v-layout>

        <v-snackbar
            v-model="api.snack.snackVisible"
            :text="api.snack.snackText"
            :color="api.snack.snackColor"
            :timeout="-1"
        >
            <template v-slot:actions>
                <v-btn
                    color="white"
                    variant="text"
                    icon="mdi-close"
                    density="compact"
                    @click="api.closeSnack"
                ></v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script setup>
import { useApi } from '@/stores/apiTemplate';

const api = useApi();
</script>

<style scoped>

</style>